import { Space, Table } from "antd";
import moment from "moment";

import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function TaskDataTable(props: any) {
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: any) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;

          case "inprogress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    // {
    //   dataIndex: "hourss",
    //   title: "hours",
    // },
    {
      dataIndex: "startDates",
      title: "startDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "endDates",
      title: "endDates",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Employee/task_view/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={props?.dataSource} // Safe fallback
        pagination={{
          defaultPageSize: 5, // Default number of rows per page
          showSizeChanger: true, // Allows user to change the number of rows per page
          pageSizeOptions: ["2", "10", "20", "50"], // Options for page size
        }}
        rowKey={(record: any) => record.id}
      />
    </div>
  );
}

export default TaskDataTable;
